module.exports = __webpack_public_path__ + "img/three2Green.cb590ebb.jpg";